import { h, Fragment} from 'preact';
import { useState } from 'preact/hooks';
import Markup from 'preact-markup';
import { GetSafeImageUrl } from '../../utils/ApiUtil';
import { DeepLinks } from './WebResultDeepLinks';

export const WebResult = props =>  {
    const [item, setItem] = useState(props.item);
    const [searchResp, setSearchResp] = useState(props.searchResp);
    const [query, setQuery] = useState(props.query);
    const [section, setSection] = useState(props.section);
    if(!item || isNaN(item.resultIndex) || item.answerType !== "WebPages") {
        return (""); //defensive check
    }
    let webBlock = searchResp.webPages.value[item.resultIndex];
    let decodedurl = webBlock.url;
    let deepLinks = (webBlock.deepLinks && webBlock.deepLinks.length > 0) ? webBlock.deepLinks : [];
    try {
        decodedurl = decodeURI(webBlock.url);
    } catch {}

    if(section === "mainline" && webBlock.thumbnailUrl) {
        let height = 92;
        let width = 92;
        return (
            <div className="result-web-with-img">
                <div className="result-block result-web">
                    <div className="ae-title result-title"><a href={webBlock.url}><Markup markup={webBlock.name} type="html" trim={false}/></a></div>
                    <div className="ae-caption result-url"><Markup markup={decodedurl} type="html" trim={false} /></div>
                    <div className="ae-para result-snippet">
                        <Markup markup={webBlock.snippet} trim={false} type="html" className="ae-line-clamp-2"/>
                    </div>
                    <DeepLinks deepLinks={deepLinks}/>
                </div>
                <div className="result-web-thumbnail-wrp">
                    <div className="result-web-thumbnail">
                        <img src={GetSafeImageUrl(webBlock.thumbnailUrl)} height={height} onLoad={(e) => {
                            if(e.target && e.target.height && e.target.width && (e.target.height/e.target.width) > 1) {
                                e.target.height = (width * e.target.height)/e.target.width
                                e.target.width = width;
                            }
                        }}/>
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className="result-block result-web">
                <div className="ae-title result-title"><a href={webBlock.url}><Markup markup={webBlock.name} type="html" trim={false}/></a></div>
                <div className="ae-caption result-url"><Markup markup={decodedurl} type="html" trim={false} /></div>
                <div className="ae-para result-snippet">
                    <Markup markup={webBlock.snippet} trim={false} type="html" className="ae-line-clamp-2"/>
                </div>
                <DeepLinks deepLinks={deepLinks}/>
            </div>
        )
    }
}